// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1rv9_","buttonText":"styles_buttonText__1sV7n","buttonIcon":"styles_buttonIcon__3YCGn"};